// This file was automatically generated from app.shared.dialog.fileReportsPrompt.html.
// Please don't edit this file by hand.

goog.provide('el8.template.app.shared.dialog.fileReportsPrompt');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.letterReceipts');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.app.shared.dialog.fileReportsPrompt.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div id="file-reports-container" class="el8DialogContainer"><p class="mb10 el8Bold">Select the attachments to file as a Report in the patient\'s chart:</p><ol><li class="clearBPM"><div class="el8TableListContainer el8BlueHighlightList attachment-div"><div class="el8TableListItem el8Clickable"><input class="attachment-checkbox" type="checkbox" data-id="LetterContent" checked="checked" />');
  el8.template.ptdata.letterReceipts.attachmentSummary({entityDescription: 'Letter', summary: ''}, output);
  output.append('</div></div></li>');
  var aList8069 = opt_data.fileables;
  var aListLen8069 = aList8069.length;
  for (var aIndex8069 = 0; aIndex8069 < aListLen8069; aIndex8069++) {
    var aData8069 = aList8069[aIndex8069];
    output.append('<li class="clearBPM"><div class="el8TableListContainer el8Clickable ', (aData8069.attachmentType == 'Report' || aData8069.attachmentType == 'VisitNote' || aData8069.attachmentType == 'NonvisitNote') ? 'el8BlueHighlightList attachment-div' : '', '"><div class="el8TableListItem"><input class="attachment-checkbox" type="checkbox" data-id="', soy.$$escapeHtml(aData8069.id), '" checked="checked" />');
    el8.template.ptdata.letterReceipts.attachmentSummary(aData8069, output);
    output.append('</div></div></li>');
  }
  output.append('</ol>');
  if (opt_data.unfileables.length) {
    output.append('<p class="el8Spacer el8777"><i>The ');
    var aList8084 = opt_data.unfileables;
    var aListLen8084 = aList8084.length;
    for (var aIndex8084 = 0; aIndex8084 < aListLen8084; aIndex8084++) {
      var aData8084 = aList8084[aIndex8084];
      output.append((! (aIndex8084 == 0)) ? ', ' : '', '<a class="view-inline-pdf" data-id="', soy.$$escapeHtml(aData8084.printableId), '">');
      el8.template.ptdata.letterReceipts._attachmentType(aData8084, output);
      output.append('</a>');
    }
    output.append(' cannot be filed as a report in the patient\'s chart. You will be able to view these documents as PDFs with the patient chart.</i></p>');
  }
  output.append('</div>');
  if (!opt_sb) return output.toString();
};
